export const ADD_POINT_OF_CONTACT_MODAL = 'ADD_POINT_OF_CONTACT_MODAL';
